 function copyCode() {
      var code = 'MEAT';
      var btn = document.getElementById('copyBtn');
      var btnText = document.getElementById('btnText');
      var toast = document.getElementById('toast');

      function showFeedback() {
        btn.classList.add('copied');
        btn.style.color = '#B0007C';
        btnText.textContent = 'Copied!';
        toast.style.opacity = '1';
        toast.style.transform = 'translateX(-50%) translateY(0)';
        setTimeout(function() {
          btn.classList.remove('copied');
          btn.style.color = '#ffffff';
          btnText.textContent = 'Copy Code';
          toast.style.opacity = '0';
          toast.style.transform = 'translateX(-50%) translateY(20px)';
        }, 2500);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(showFeedback).catch(function() {
          fallbackCopy(code);
          showFeedback();
        });
      } else {
        fallbackCopy(code);
        showFeedback();
      }
    }

    function fallbackCopy(text) {
      var el = document.createElement('textarea');
      el.value = text;
      el.style.position = 'fixed';
      el.style.opacity = '0';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    }

window.addEventListener('scroll', function () {
    const modal = document.getElementById('modal_st');
      const header = document.getElementById('header_open_st');
        const scrolled = window.scrollY > 100; // <-- increased threshold
          const isMobile = window.innerWidth <= 768; // adjust breakpoint if needed

            // #modal_st: visible at top, hidden on scroll (only on mobile)
              if (modal) {
                  if (isMobile) {
                        modal.style.visibility = scrolled ? 'hidden' : 'visible';
                            } else {
                                  modal.style.visibility = 'visible'; // always visible on desktop
                                      }
                                        }

                                          // #header_open_st: hidden at top, visible on scroll (on all devices)
                                            if (header) {
                                                header.style.visibility = scrolled ? 'visible' : 'hidden';
                                                  }
                                                  });


document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.apps');

  const fixedText = 'Search for ';
  const words = ['Bleuface…','Sunscreen…', 'Maybelline…', 'Loreal…', 'Bioaqua…', 'Garnier…', 'Sheglam…'];

  const typingSpeed = 80;
  const deletingSpeed = 40;
  const pauseTime = 1500;

  elements.forEach((el) => {
    let wordIndex = 0;
    let charIndex = 0;
    let isDeleting = false;

    function loop() {
      const currentWord = words[wordIndex];

      if (!isDeleting) {
        charIndex++;
        el.textContent = fixedText + currentWord.substring(0, charIndex);

        if (charIndex === currentWord.length) {
          isDeleting = true;
          setTimeout(loop, pauseTime);
          return;
        }
      } else {
        charIndex--;
        el.textContent = fixedText + currentWord.substring(0, charIndex);

        if (charIndex === 0) {
          isDeleting = false;
          wordIndex = (wordIndex + 1) % words.length;
        }
      }

      setTimeout(loop, isDeleting ? deletingSpeed : typingSpeed);
    }

    // start
    el.textContent = fixedText;
    loop();
  });
});



